export default __webpack_public_path__ + "static/media/panel.314a53dd.png";